(() => {
  if (window.CTReviewPhotoMarqueeSwipe) {
    window.CTReviewPhotoMarqueeSwipe.initAll();
    return;
  }

  const RESUME_DELAY = 900;
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function initRow(row) {
    if (row.dataset.ctSwipeReady === 'true') return;

    const track = row.querySelector(
      '.ct-review-photo-marquee__track'
    );

    const group = track?.querySelector(
      '.ct-review-photo-marquee__group'
    );

    if (!track || !group) return;

    row.dataset.ctSwipeReady = 'true';

    let pointerId = null;
    let startX = 0;
    let startTime = 0;
    let moved = false;
    let blockClick = false;
    let resumeTimer = null;
    let activeAnimation = null;

    function getAnimation() {
      const animations = track.getAnimations();

      return (
        animations.find(
          (animation) =>
            animation.animationName ===
            'ct-review-photo-marquee-scroll'
        ) || animations[0]
      );
    }

    function getDuration(animation) {
      const timing = animation.effect?.getTiming();
      const duration = Number(timing?.duration);

      return duration > 0 ? duration : 36000;
    }

    function finishDrag(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;

      if (row.hasPointerCapture?.(pointerId)) {
        row.releasePointerCapture(pointerId);
      }

      row.classList.remove(
        'ct-review-photo-marquee__row--dragging'
      );

      blockClick = moved;
      pointerId = null;

      clearTimeout(resumeTimer);

      resumeTimer = setTimeout(() => {
        if (activeAnimation && row.isConnected) {
          activeAnimation.play();
        }
      }, RESUME_DELAY);
    }

    row.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) {
          return;
        }

        if (reducedMotion.matches) return;

        activeAnimation = getAnimation();

        if (!activeAnimation) return;

        clearTimeout(resumeTimer);

        pointerId = event.pointerId;
        startX = event.clientX;
        startTime = Number(activeAnimation.currentTime) || 0;
        moved = false;
        blockClick = false;

        activeAnimation.pause();

        row.setPointerCapture?.(pointerId);

        row.classList.add(
          'ct-review-photo-marquee__row--dragging'
        );
      },
      { passive: true }
    );

    row.addEventListener(
      'pointermove',
      (event) => {
        if (pointerId === null || event.pointerId !== pointerId) {
          return;
        }

        const deltaX = event.clientX - startX;

        if (Math.abs(deltaX) > 5) {
          moved = true;
        }

        if (!moved || !activeAnimation) return;

        const groupWidth = group.getBoundingClientRect().width;
        const duration = getDuration(activeAnimation);

        if (!groupWidth) return;

        /*
         * Hàng chạy trái: kéo trái làm thời gian tăng.
         * Hàng chạy phải: kéo trái làm thời gian giảm.
         */
        const direction = row.classList.contains(
          'ct-review-photo-marquee__row--right'
        )
          ? -1
          : 1;

        const timeChange =
          (-deltaX / groupWidth) * duration * direction;

        const rawTime = startTime + timeChange;
        const normalizedTime =
          ((rawTime % duration) + duration) % duration;

        activeAnimation.currentTime =
          normalizedTime + duration * 100;

        event.preventDefault();
      },
      { passive: false }
    );

    row.addEventListener('pointerup', finishDrag);
    row.addEventListener('pointercancel', finishDrag);

    row.addEventListener(
      'click',
      (event) => {
        if (!blockClick) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        blockClick = false;
      },
      true
    );

    row.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });
  }

  function initAll(container = document) {
    container
      .querySelectorAll('.ct-review-photo-marquee__row')
      .forEach(initRow);
  }

  window.CTReviewPhotoMarqueeSwipe = {
    initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();